import { ChangeDetectionStrategy, Component, input } from '@angular/core';

const DEFAULT_HEIGHT = '20px';

function normalizeHeight(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return DEFAULT_HEIGHT;
  }

  if (typeof value === 'number') {
    return value >= 0 ? `${value}px` : DEFAULT_HEIGHT;
  }

  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return DEFAULT_HEIGHT;
  }

  if (/^-(?:\d+|\d*\.\d+)$/.test(trimmedValue)) {
    return DEFAULT_HEIGHT;
  }

  return /^(?:\d+|\d*\.\d+)$/.test(trimmedValue)
    ? `${trimmedValue}px`
    : trimmedValue;
}

@Component({
  selector: 'rv-skeleton',
  template: '',
  styleUrls: ['./skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--rv-skeleton-height]': 'height()',
  },
})
export class SkeletonComponent {
  height = input(DEFAULT_HEIGHT, { transform: normalizeHeight });
}
